import '.bd{flex:1;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.jj{gap:3rem;}.ssr-plugin'
import '.aq{justify-content:center;}.ssr-plugin'
import '.ao{position:relative;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import { PhaseType } from '@schema/phase'
import {
  creationGuideDisplay,
  InitiativeCreationStep,
} from '../../shared/workflow'
import { ReactNode } from 'react'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { Text } from '@app/components/core/typography/Text'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'

export const CreationGuide = ({
  selectedPhaseType,
  currentStep,
  steps: stepsOverride,
  stepTitles,
  stepDescriptions,
  illustration,
  children,
}: {
  selectedPhaseType?: PhaseType | null
  currentStep: string
  steps?: string[]
  stepTitles?: Record<string, string>
  stepDescriptions?: Record<string, string | null>
  illustration?: ReactNode
  children: ReactNode
}) => {
  const steps =
    stepsOverride ??
    creationGuideDisplay(
      selectedPhaseType ?? null,
      currentStep as InitiativeCreationStep,
    )
  const isMobile = useMediaQuery()

  const assignmentProps = {
    steps,
    activeStep: currentStep,
    illustration,
    stepTitles,
    stepDescriptions,
  }

  return (
    <div className="bd a jj aq ao"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'stretch' : 'center',
        paddingInline: isMobile ? '1rem' : '3rem',}}
    >
      <CreationGuideAssignment {...assignmentProps} />
      <Column
        style={{ flexBasis: isMobile ? '100%' : '50%', alignItems: 'stretch' }}
      >
        {children}
      </Column>
    </div>
  )
}

const CreationGuideAssignment = ({
  steps,
  activeStep,
  illustration,
  stepTitles,
  stepDescriptions,
}: {
  steps: string[]
  activeStep: string
  illustration?: ReactNode
  stepTitles?: Record<string, string>
  stepDescriptions?: Record<string, string | null>
}) => {
  const translations = useTranslations().app.dashboard.initiative.creation
  const hasStepNumbers = steps.length > 1
  const active = steps.length === 1 ? steps[0] : activeStep
  const isMobile = useMediaQuery()

  return (
    <Column
      gap="2rem"
      style={{ flexBasis: isMobile ? '100%' : '50%', alignItems: 'stretch' }}
    >
      {illustration}
      {steps.map((step, index) => {
        const title =
          stepTitles?.[step] ??
          translations.creationStepTitles[step as InitiativeCreationStep]
        const description =
          stepDescriptions?.[step] ??
          translations.creationStepDescriptions[step as InitiativeCreationStep]
        return (
          <span key={index}>
            <Title.Hx
              title={step === active ? 'H2' : 'H4'}
              style={{
                color:
                  step === active
                    ? 'var(--brand-secondary)'
                    : 'var(--gray-300)',
              }}
            >
              {(hasStepNumbers ? `${index + 1}. ` : '') + title}
            </Title.Hx>
            {description && <Text.Medium>{description}</Text.Medium>}
          </span>
        )
      })}
    </Column>
  )
}
